export const DELETE = 'delete';
export const UPDATE = 'update';
export const CREATE = 'create';
